@if (HasRequiredPermissions) {
  <div class="bg-white p-6 my-8 rounded-lg shadow w-full max-w-none">
    <div class="mb-4">
      <h1 class="text-lg font-medium text-gray-700" data-testid="list-title">
        {{ 'entities.buzzer-config.pluralName' | translate }} ({{ totalSeen }}/{{ listView()?.entities()?.total }})
      </h1>
    </div>
    <app-list-view [entityType]="ComponentEntityClass"
      [contextMenuItems]="contextMenuItems"
      [showActions]="true"
      [fuseauxParSite]="fuseauxParSite"
      [canEdit]="canEdit.bind(this)"
      (entitySelected)="selectSingleItem($event)"
      (editAction)="editSelectedItem($event)"
      (deleteAction)="deleteSelectedItem($event)"
      [dismissEntity]="dismissEntityState.bind(this)"
      [onDismissAdded]="dismissEntityState.bind(this)"
      [onRowDismiss]="handleRowDismiss.bind(this)"
                   [pagination]="{
                      enabled: true,
                      pageLengths: [5, 10, 20, 50, 100, 300],
                      defaultPageLength: 5,
                      searchColumns: ['startDate', 'endDate', 'status', 'employee.fullName'],
                      sortableColumns: null
                    }"
      [paginatorType]="'button'"
      [showHeader]="false"
      [createDisabled]="!canCreateBuzzer"
      (createButtonClick)="openCreateModal()">
      <div slot="custom-filters" class="px-6 py-2 flex gap-2 items-center">
        <button (click)="showFilter.set('all')"
          class="px-3 py-1 text-xs font-medium rounded-md transition-colors"
          [class.bg-blue-600]="showFilter() === 'all'"
          [class.text-white]="showFilter() === 'all'"
          [class.bg-gray-200]="showFilter() !== 'all'">
          {{'All' | translate}}
        </button>
        <button (click)="showFilter.set('visible')"
          class="px-3 py-1 text-xs font-medium rounded-md transition-colors"
          [class.bg-blue-600]="showFilter() === 'visible'"
          [class.text-white]="showFilter() === 'visible'"
          [class.bg-gray-200]="showFilter() !== 'visible'">
          {{'Visible' | translate}}
        </button>
      </div>
      <!-- Colonne Numero -->
      <app-list-table-column key="numero"
        title="{{ 'entities.buzzer-config.propreties.numero' | translate }}"
        type="text"
        [sortable]="true"
        align="center">
      </app-list-table-column>
      <!-- Colonne Sujet (tronque) -->
      <app-list-table-column key="subjectTranslations"
        title="{{ 'entities.buzzer-config.propreties.subject' | translate }}"
        type="custom"
        align="left">
        <ng-template #customTemplate let-entity>
          {{ getSubject(entity) }}
        </ng-template>
      </app-list-table-column>
      <!-- Colonne StartDate -->
      <app-list-table-column key="startDate"
        title="{{ 'entities.buzzer-config.propreties.startDate' | translate }}"
        type="datetime"
        [sortable]="true"
        align="left">
      </app-list-table-column>
      <!-- Colonne EndDate -->
      <app-list-table-column key="endDate"
        title="{{ 'entities.buzzer-config.propreties.endDate' | translate }}"
        type="datetime"
        [sortable]="true"
        align="left">
      </app-list-table-column>
      <!-- Colonne Employee -->
      <app-list-table-column key="employee.fullName"
        title="{{ 'entities.buzzer-config.propreties.employee' | translate }}"
        type="text"
        [sortable]="true"
        align="left">
      </app-list-table-column>
      <!-- Colonne Status -->
      <app-list-table-column key="status"
        title="{{ 'entities.buzzer-config.propreties.status' | translate }}"
        type="custom">
        <ng-template #customTemplate let-entity>
          <app-reactive-badge [status]="$safeNavigationMigration(entity?.status)"
            [lookupData]="buzzerStatusLookup()"
            [Skin]="Skin"
            [isEditMode]="false">
          </app-reactive-badge>
        </ng-template>
      </app-list-table-column>
    </app-list-view>
    <!-- Vue de détail en modale centrée -->
    @if (isModalOpen()) {
      <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40" (click)="closeModal(false)">
        <div class="bg-white rounded-xl shadow-2xl overflow-hidden" style="width:80%" (click)="$event.stopPropagation()">
          <app-buzzer-config-detail #buzzerConfigDetail
            [isModal]="true"
            [dataService]="dataService"
            (closeModal)="closeModal($event)"
            (itemSaved)="onItemUpdated($event)"
            (databaseUpdated)="closeModal(true)"
            [EntityInstance]="selectedItem()">
          </app-buzzer-config-detail>
        </div>
      </div>
    }
  </div>
}
